import Vue from "vue";

// 입력항목 필드 컴포넌트
const InputComponent = Vue.component("InputComponent", {
  data: function () {
    return {
      type: "",
    };
  },

  mounted() {
    this.type = this.params.value;
  },

  watch: {
    "params.data.useYn"() {
      if (this.params.data.useYn === "Y") {
        this.params.data.isRequired = "required";
      } else {
        this.params.data.isRequired = "select";
      }
      console.log("type", this.type);
      console.log("this.params.data", this.params.data);
    },
  },

  template:
    '<div><input type="checkbox" v-if="type === \'select\'" class="h-17px w-17px" true-value="Y" false-value="N" v-model="params.data.useYn"/> <div v-else></div> </div>',
});

// 필수입력 필드 컴포넌트
const RequiredComponent = Vue.component("RequiredComponent", {
  data: function () {
    return {
      type: "",
    };
  },

  mounted() {
    this.type = this.params.value;
  },
  // watch: {
  //   "params.data.useYn"() {
  //     if (this.params.data.useYn === "Y" && this.params.data.itemName === '사번') {
  //       this.type = this.params.data.isRequired;
  //     } else if (this.params.data.itemName === '사번') {
  //       this.type = this.params.data.isRequired;
  //     }
  //   },
  // },

  template:
    '<div><input v-if="type === \'select\'" class="h-17px w-17px" true-value="Y" false-value="N" type="checkbox" v-model="params.data.necessaryYn"/> <div v-else>필수</div> </div>',
});

// 항목 필드 컴포넌트
const ItemComponent = Vue.component("ItemComponent", {
  data: function () {
    return {
      type: "",
    };
  },

  mounted() {
    this.type = this.params.value;
  },

  template:
    '<div><div v-if="type === \'email\'">E-mail@ <input type="text" class="w-130px" v-model="params.data.itemName" /></div> <div v-else-if="type !== \'\'">{{params.data.itemName}}</div><div v-else><input type="text" v-model="params.data.itemName" class="w-150px" /></div> </div>',
});

// 항목 안내 문구 필드 컴포넌트
const InfoTextComponent = Vue.component("InfoTextComponent", {
  data: function () {
    return {
      type: "",
    };
  },

  methods: {
    openKaKaoSearchAddress() {
      new window.daum.Postcode({
        oncomplete: (response) => {
          this.params.data.itemMessage = response.address;
        },
      }).open();
    },
  },

  mounted() {
    this.type = this.params.data.itemName;
  },

  template:
    '<div><input type="text" style="width: 285px;" v-if="type === \'비밀번호\'" v-model="params.data.itemMessage" placeholder="수강신청 내역 확인을 위해 필요합니다." /> <input type="text" @click="openKaKaoSearchAddress" style="width: 285px;" v-else-if="type === \'주소\'" v-model="params.data.itemMessage" /> <input type="text" style="width: 285px" v-model="params.data.itemMessage" v-else /></div>',
});

import OptionModal from "@/components/reg/userInfo/optionModal.vue";

// 사용자 입력 필드 컴포넌트
const CustomInputComponent = Vue.component("CustomInputComponent", {
  components: {
    OptionModal,
  },
  data: function () {
    return {
      type: "",
      inputType: "direct",
      isModalOpened: false,
      itemName: "",
    };
  },

  mounted() {
    this.type = this.params.data.inputType;
    this.itemName = this.params.data.itemName;
    if (this.params.data.optionInfo === "direct") {
      this.inputType = "direct";
    } else if (this.params.data.optionInfo === "descriptive") {
      this.inputType = "descriptive";
    } else {
      this.inputType = "select";
    }
  },

  watch: {
    "params.data.inputType"() {},
  },

  methods: {
    openModal() {
      this.params.context.componentParent.modalIndex = this.params.rowIndex;
      this.params.context.componentParent.parentOption =
        this.params.data.optionInfo;
      this.params.context.componentParent.isModalOpened = true;
    },
    test(e) {
      console.log(e);
      console.log(e.target.value);
      console.log("!!!");

      console.log(this.params.data.idx);
      console.log(this.params.context.componentParent.userInfoList);

      const findIdx =
        this.params.context.componentParent.userInfoList.findIndex(
          (item) => item["idx"] === this.params.data.idx,
        );

      if (findIdx > -1) {
        console.log(
          (this.params.context.componentParent.userInfoList[findIdx][
            "optionInfo"
          ] = e.target.value),
        );
      }
    },
  },

  template:
    "<div><div v-if=\"type === 'direct' && !['이름', '비밀번호', '사번', '휴대전화번호'].includes(itemName) \"><input type=\"radio\" @click=\"test\" v-model=\"inputType\" value=\"direct\"/> 직접입력 " +
    '<input v-if="![ \'회사\', \'직급\', \'부서\', \'공인시험점수\',\'1차 소속/ 2차 소속\'].includes(itemName)" type="radio" class="ml-05" v-model="inputType" @click="test" value="descriptive"/>' +
    "<span v-if=\"![ '회사', '직급', '부서', '공인시험점수','1차 소속/ 2차 소속'].includes(itemName)\"> 서술형입력 </span> " +
    '<input type="radio" class="ml-05" @click="test" v-model="inputType" value="select"/> 옵션선택 <button type="button" :disabled="inputType === \'direct\'" class="admin-btn-default ml-05" @click="openModal()" data-toggle="modal" data-target="#option">입력</button></div></div>',
});

export {
  InputComponent,
  RequiredComponent,
  ItemComponent,
  InfoTextComponent,
  CustomInputComponent,
};
